// extracted by mini-css-extract-plugin
module.exports = {"ActiveLabel":"ActiveLabel_ActiveLabel__qizOH"};